import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { filter, map } from 'rxjs';
import { VersionCheckService } from './Services/version-check.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,ButtonModule, ToastModule, RippleModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Provider Portal';
  constructor(private titleService: Title, private router: Router, private activatedRoute: ActivatedRoute, private versionCheck: VersionCheckService) {
    this.versionCheck.start();

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child?.firstChild) {
            child = child.firstChild;
          }
          return child?.snapshot.data['title'];
        })
      )
      .subscribe((pageTitle: string | undefined) => {
        const appTitle = 'Provider Portal'; 
        if (pageTitle) {
          this.titleService.setTitle(` ${pageTitle} | ${appTitle}`);
        } else {
          this.titleService.setTitle(appTitle); 
        }
      });
  }
  
}
